const types = {
	//Get Template name
	GET_VENDOR_DETAILS_START: "GET_VENDOR_DETAILS_START",
	GET_VENDOR_DETAILS_SUCCESS: "GET_VENDOR_DETAILS_SUCCESS",
	GET_VENDOR_DETAILS_ERROR: "GET_VENDOR_DETAILS_ERROR",
	GET_VENDOR_DETAILS_RESET: "GET_VENDOR_DETAILS_RESET",

	//Create Template name
	CREATE_VENDOR_DETAILS_START: "CREATE_VENDOR_DETAILS_START",
	CREATE_VENDOR_DETAILS_SUCCESS: "CREATE_VENDOR_DETAILS_SUCCESS",
	CREATE_VENDOR_DETAILS_ERROR: "CREATE_VENDOR_DETAILS_ERROR",
	CREATE_VENDOR_DETAILS_RESET: "CREATE_VENDOR_DETAILS_RESET",

	//delete Template name
	DELETE_VENDOR_DETAILS_START: "DELETE_VENDOR_DETAILS_START",
	DELETE_VENDOR_DETAILS_SUCCESS: "DELETE_VENDOR_DETAILS_SUCCESS",
	DELETE_VENDOR_DETAILS_ERROR: "DELETE_VENDOR_DETAILS_ERROR",
	DELETE_VENDOR_DETAILS_RESET: "DELETE_VENDOR_DETAILS_RESET",

	//update Template name
	UPDATE_VENDOR_DETAILS_START: "UPDATE_VENDOR_DETAILS_START",
	UPDATE_VENDOR_DETAILS_SUCCESS: "UPDATE_VENDOR_DETAILS_SUCCESS",
	UPDATE_VENDOR_DETAILS_ERROR: "UPDATE_VENDOR_DETAILS_ERROR",
	UPDATE_VENDOR_DETAILS_RESET: "UPDATE_VENDOR_DETAILS_RESET",

	//single item  name
	SINGLE_VENDOR_DETAILS_START: "SINGLE_VENDOR_DETAILS_START",
	SINGLE_VENDOR_DETAILS_SUCCESS: "SINGLE_VENDOR_DETAILS_SUCCESS",
	SINGLE_VENDOR_DETAILS_ERROR: "SINGLE_VENDOR_DETAILS_ERROR",
	SINGLE_VENDOR_DETAILS_RESET: "SINGLE_VENDOR_DETAILS_RESET",
};

export default types;
